export const mainNavbarItems = [
    {
        id: 1,
        icon: '',
        label: 'Campaign viewer',
        route: 'viewer'
    }
]